var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8084_22168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7301 1.25006L0.410088 20.9201C-0.699912 22.7001 0.570088 25.0001 2.67009 25.0001H27.3101C29.4101 25.0001 30.6801 22.6901 29.5701 20.9201L17.2501 1.25006C16.2101 -0.419941 13.7801 -0.419941 12.7301 1.25006Z",
    fill: "#F9A670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5198 14.88H14.4598C14.1998 14.88 13.9798 14.67 13.9598 14.41L13.5198 7.41C13.4998 7.12 13.7298 6.88 14.0198 6.88H15.9598C16.2498 6.88 16.4798 7.12 16.4598 7.41L16.0198 14.41C15.9998 14.67 15.7898 14.88 15.5198 14.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9902 19.12C15.8187 19.12 16.4902 18.4484 16.4902 17.62C16.4902 16.7916 15.8187 16.12 14.9902 16.12C14.1618 16.12 13.4902 16.7916 13.4902 17.62C13.4902 18.4484 14.1618 19.12 14.9902 19.12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8084_22168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.98,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.37c11c5645f2388351f7e05b86a834a9.svg";
export { ForwardRef as ReactComponent };